import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import QuantityPrice from '../QuantityPrice'
import Button from 'components/common/Button/Button'
import CompatibilityLabel from 'components/common/CompatibilityLabel'
import ExpanderGroup from 'components/common/ExpanderGroup'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import SpecialOrder from 'components/common/SpecialOrder'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import ProductPromotionsAndSpecs from '../ProductPromotionsAndSpecs'
import { ButtonWithAddToQuoteHandler, MobileButtonWithAddToQuoteHandler } from '../AddToQuoteButton'
import { arrayHasValues, isInventoryStatusLoaded } from 'helpers/utils'
import { getInventoryStatus } from './helpers'
import {
  Block,
  Cell,
  ExpanderButtonContent,
  RightUpdatingBlock,
  Tire,
  Logo,
  TireLineName,
  PriceLink,
  CustomButton,
  ButtonColumns,
  ProductHeader,
  LeftCell,
  TireImageWrapper,
  ProductDetails,
  ProductDetailsBottom,
  CompatibilityWrapper,
  SizeWrapper,
  Rating,
  RightCell,
  WarrantyWrapper,
  BadgeWrapper,
  WarrantyBadgeTitleWrapper,
  CompareBtnWrapper,
  AvailabilityWrapper
} from './styles'
import TireSpecification from '../TireSpecification'
import PromotionTeaser from '../PromotionTeaser'
import WarrantyBadge from 'components/common/WarrantyBadge'
import TireSize from '../TireSize'
import FavoriteButton from '../../../MyFavorites/FavoriteButton'
import ProductFlag from 'components/common/ProductFlag/ProductFlag'
import TireAvailability from 'components/common/TireAvailability'
import {
  OE_TOOLTIP_MESSAGE,
  OE_FLAG_TYPE,
  OE_FLAG_NAME,
  EVS_FLAG_TYPE,
  EVS_FLAG_NAME,
  EVS_TOOLTIP_MESSAGE,
  EVS_FLAG_ICON_NAME,
  EVC_FLAG_TYPE,
  EVC_FLAG_NAME,
  EVC_TOOLTIP_MESSAGE,
  EVC_FLAG_ICON_NAME
} from 'components/common/ProductFlag/constans'
import useTireAvailabilityStatus from 'src/hooks/useTireAvailabilityStatus.js'

const ProductBlock = ({
  className,
  brandName,
  compareDisabled,
  compareBtnText,
  expanderMenu,
  staggeredSkuId,
  quantityInputId,
  skuId,
  title,
  rearSkuId,
  productSkuId,
  product: {
    attributes: {
      bvId,
      imageUrl,
      brandLogoUrl,
      ratingScore: [ratingScore],
      tireLineName: [tireLineName],
      zeroPriceItemMessage: [zeroPriceItemMessage] = [],
      tireDetailUrl: [tireDetailUrl],
      frontTire: [frontTire],
      rearTire: [rearTire],
      warrantyTitle,
      sizeRear,
      sizeFront,
      priceTitle,
      price,
      priceOld,
      priceSet,
      inventoryInfo,
      warrantyBadges: [{
        name,
        value
      } = {}] = [],
      isSpecialOrderItem: [isSpecialOrder]
    } = {}
  } = {},
  isTrailer,
  reviewsLink,
  handleProductClick,
  handleFrontQuantityChange,
  handleRearQuantityChange,
  countFront,
  countRear,
  quantityUpdated,
  defaultValue,
  isAllCompatible,
  disableAddToQuote,
  compatibilityState,
  vehicleName,
  promotions,
  promotionsPreviewItems,
  promotionsRestItems,
  specification,
  handleAddNewVehicle,
  handleCompareTrayAdd,
  myStore,
  showStoreLocatorModal,
  handleFindLowerPriceClick,
  onClick,
  handleBeforeRemoveFavorite,
  isOeItem,
  isEvItem,
  contextType,
  inventoryStatuses,
  isPilotStore,
  itemEVType
}) => {
  /* this custom hook is designed to make inventory service call when loading favorites items
  and when quantity is updated */
  const [availability, setAvailability] = useTireAvailabilityStatus({
    countFront,
    countRear,
    brandName,
    frontTireBvId: contextType === 'plp' ? bvId[0] : bvId,
    rearTireBvId: rearTire?.bvId,
    storeNumber: myStore?.storeNumber,
    dependencies: [countFront, countRear, isPilotStore],
    contextType,
    quantityUpdated,
    productSkuId,
    isPilotStore
  })

  /* function inside the hook will ony run for PLP page to convert the inventory
  info object into the structure require for rendering tire availability component */
  useEffect(() => {
    if (contextType === 'plp' && inventoryInfo?.length) {
      setAvailability(getInventoryStatus(inventoryInfo[0]))
    }
  }, [])

  const renderTireAvailability = (
    <AvailabilityWrapper>
      <TireAvailability availability={ availability } />
    </AvailabilityWrapper>
  )

  return (
    <Block>
      <Cell>
        <Block>
          <ProductHeader>
            <LeftCell>
              <Media.Desktop>
                <Link to={ tireDetailUrl } onClick={ handleProductClick }>
                  <Tire
                    data-at-serp-tire-img
                    src={ `${imageUrl}?$BOT-TireSearchResult-Tire-Desktop-w180-h180$` }
                    alt="Navigate to product details page" />
                </Link>
              </Media.Desktop>
              <Media.Mobile>
                <TireImageWrapper>
                  <Link to={ tireDetailUrl } onClick={ handleProductClick }>
                    <Tire
                      data-at-serp-tire-img
                      src={ `${imageUrl}?$BOT-TireSearchResult-Tire-Mobile-w86-h86$` }
                      alt="Navigate to product details page" />
                  </Link>
                </TireImageWrapper>
              </Media.Mobile>
              <ProductDetails>
                <Link data-at-serp-tire-title to={ tireDetailUrl } onClick={ handleProductClick } >
                  <div>
                    <BrandLogo
                      data-at-serp-tire-brandlogo
                      src={ `${brandLogoUrl}?$BOT-Tire-Search-Result-Brand-Desktop-h30$` }
                      alt={ `${brandName} brand logo` } />
                  </div>
                  <TireLineName data-at-serp-tire-linename noMargin bolder>
                    { tireLineName }
                  </TireLineName>
                </Link>
                <ProductDetailsBottom>
                  <Media.Desktop>
                    <CompatibilityWrapper>
                      {
                        !isAllCompatible && !isTrailer &&
                        <CompatibilityLabel
                          status={ compatibilityState }
                          handleAddNewVehicle={ handleAddNewVehicle }
                          vehicle={ vehicleName } />
                      }
                      {
                        isSpecialOrder && <SpecialOrder />
                      }
                    </CompatibilityWrapper>
                  </Media.Desktop>
                  <SizeWrapper>
                    {
                      frontTire &&
                      <TireSize data-at-front-size title={ rearTire ? 'Front' : '' } size={ frontTire.frontTireSize } { ...frontTire } />
                    }
                    {
                      rearTire &&
                      <TireSize data-at-rear-size title="Rear" size={ rearTire.rearTireSize } { ...rearTire } />
                    }
                  </SizeWrapper>
                  <Media.Desktop>
                    <Rating bvId={ bvId } reviewName={ tireLineName } reviewsLink={ reviewsLink } />
                  </Media.Desktop>
                  <Media.Desktop>
                    { (isOeItem || isEvItem) &&
                    <ProductFlagWrapper>
                      { isOeItem &&
                        <ProductFlag
                          name={ OE_FLAG_NAME }
                          flagType={ OE_FLAG_TYPE }
                          tooltipMessage={ OE_TOOLTIP_MESSAGE }
                          asset="icon-info-blue-regular"
                          alternative="icon-info-blue-solid" /> }
                      { (isEvItem && itemEVType === EVS_FLAG_TYPE) &&
                        <ProductFlag
                          name={ EVS_FLAG_NAME }
                          flagType={ EVS_FLAG_ICON_NAME }
                          tooltipMessage={ EVS_TOOLTIP_MESSAGE }
                          asset="icon-info-blue-regular"
                          alternative="icon-info-blue-solid" />
                      }
                      { (isEvItem && itemEVType === EVC_FLAG_TYPE) &&
                        <ProductFlag
                          name={ EVC_FLAG_NAME }
                          flagType={ EVC_FLAG_ICON_NAME }
                          tooltipMessage={ EVC_TOOLTIP_MESSAGE }
                          asset="icon-info-blue-regular"
                          alternative="icon-info-blue-solid" />
                      }
                    </ProductFlagWrapper>
                    }
                  </Media.Desktop>
                </ProductDetailsBottom>
              </ProductDetails>
            </LeftCell>
            <RightCell>
              <Media.Mobile>
                <CompatibilityWrapper>
                  {
                    !isAllCompatible && !isTrailer &&
                    <CompatibilityLabel
                      status={ compatibilityState }
                      handleAddNewVehicle={ handleAddNewVehicle }
                      vehicle={ vehicleName } />
                  }
                  {
                    isSpecialOrder && <SpecialOrder />
                  }
                </CompatibilityWrapper>
                <Rating bvId={ bvId } reviewName={ tireLineName } reviewsLink={ reviewsLink } />
                { (isOeItem || isEvItem) &&
                <ProductFlagWrapper>
                  { isOeItem &&
                    <ProductFlag
                      name={ OE_FLAG_NAME }
                      flagType={ OE_FLAG_TYPE }
                      tooltipMessage={ OE_TOOLTIP_MESSAGE }
                      asset="icon-info-blue-regular"
                      alternative="icon-info-blue-solid" /> }
                  { (isEvItem && itemEVType === EVS_FLAG_TYPE) &&
                    <ProductFlag
                      name={ EVS_FLAG_NAME }
                      flagType={ EVS_FLAG_ICON_NAME }
                      tooltipMessage={ EVS_TOOLTIP_MESSAGE }
                      asset="icon-info-blue-regular"
                      alternative="icon-info-blue-solid" />
                  }
                  { (isEvItem && itemEVType === EVC_FLAG_TYPE) &&
                    <ProductFlag
                      name={ EVC_FLAG_NAME }
                      flagType={ EVC_FLAG_ICON_NAME }
                      tooltipMessage={ EVC_TOOLTIP_MESSAGE }
                      asset="icon-info-blue-regular"
                      alternative="icon-info-blue-solid" />
                  }
                </ProductFlagWrapper>
                }
              </Media.Mobile>
              <WarrantyWrapper>
                <BadgeWrapper>
                  <WarrantyBadge name={ name } warranty={ value } />
                </BadgeWrapper>
                <WarrantyBadgeTitleWrapper name={ name } value={ value } />
              </WarrantyWrapper>
            </RightCell>

            <FavoriteButtonHeart
              countFront={ countFront }
              countRear={ countRear }
              skuId={ productSkuId }
              tireLineName={ tireLineName }
              imageUrl={ imageUrl }
              brandLogoUrl={ brandLogoUrl }
              frontTireSize={ frontTire && frontTire.frontTireSize }
              rearTireSize={ rearTire && rearTire.rearTireSize }
              onBeforeRemoveFavorite={ handleBeforeRemoveFavorite } />
          </ProductHeader>
        </Block>

        <Media.Mobile>
          <ExpanderGroup menu={ expanderMenu }>
            {
              arrayHasValues(promotions) &&
              <ExpanderButtonContent>
                <PromotionTeaser promotions={ promotions } />
              </ExpanderButtonContent>
            }
            <ExpanderButtonContent>
              <TireSpecification
                specification={ frontTire.specification }
                title={ sizeRear ? 'Front' : '' }
                clear
                hideCaption />
              {/* TODO use real tire rear specifications */}
              {
                sizeRear &&
                <TireSpecification
                  specification={ frontTire.specification }
                  title={ 'Rear' }
                  hideCaption
                  clear />
              }
            </ExpanderButtonContent>
          </ExpanderGroup>
        </Media.Mobile>

        <Media.Desktop>
          <ProductPromotionsAndSpecs
            promotions={ promotions }
            promotionsPreviewItems={ promotionsPreviewItems }
            promotionsRestItems={ promotionsRestItems }
            myStore={ myStore }
            frontTire={ frontTire }
            rearTire={ rearTire } />
        </Media.Desktop>
      </Cell>
      <RightUpdatingBlock
        name={ ADDING_TO_SHOPPING_QUOTE }
        value={ productSkuId }
        condition={ isInventoryStatusLoaded(inventoryStatuses, productSkuId) }>
        {renderTireAvailability}
        {
          frontTire &&
          <QuantityPrice
            priceTitle={ rearTire ? 'Front' : '' }
            quantityInputId={ quantityInputId }
            defaultValue={ countFront }
            priceOld={ frontTire.listPrice }
            priceSale={ frontTire.salePrice }
            hasMapPrice={ frontTire.hasMapPrice }
            seePriceIncartMessage={ frontTire.seePriceIncartMessage }
            zeroPriceItemMessage={ zeroPriceItemMessage }
            handleQuantityChange={ handleFrontQuantityChange }
            showStoreLocatorModal={ showStoreLocatorModal }
            myStore={ myStore }
            count={ countFront } />
        }
        {
          rearTire &&
          <QuantityPrice
            priceTitle="Rear"
            quantityInputId={ quantityInputId }
            defaultValue={ countRear }
            priceOld={ rearTire.listPrice }
            priceSale={ rearTire.salePrice }
            hasMapPrice={ rearTire.hasMapPrice }
            seePriceIncartMessage={ rearTire.seePriceIncartMessage }
            zeroPriceItemMessage={ zeroPriceItemMessage }
            handleQuantityChange={ handleRearQuantityChange }
            showStoreLocatorModal={ showStoreLocatorModal }
            myStore={ myStore }
            count={ countRear } />
        }
        <Media.Mobile>
          <ButtonColumns width="50% 50%">
            <CustomButton
              data-at-serp-tire-compare
              narrow
              full
              secondary
              disabled={ compareDisabled }
              onClick={ handleCompareTrayAdd }>
              + Compare
            </CustomButton>
            <MobileButtonWithAddToQuoteHandler
              full="mobile"
              disabled={ disableAddToQuote }
              productInfo={{
                skuId,
                rearSkuId,
                staggeredSkuId,
                quantity: countFront,
                rearSKUQuantity: countRear,
                oeFlag: isOeItem,
                evFlag: isEvItem
              }} />
          </ButtonColumns>
        </Media.Mobile>
        <Media.Desktop>
          <ButtonWithAddToQuoteHandler
            disabled={ disableAddToQuote }
            productInfo={{
              skuId,
              rearSkuId,
              staggeredSkuId,
              quantity: countFront,
              rearSKUQuantity: countRear,
              oeFlag: isOeItem,
              evFlag: isEvItem
            }} />
          <CompareBtnWrapper>
            <Button
              data-at-serp-tire-compare-hello
              stacked
              secondary
              narrow
              full
              disabled={ compareDisabled }
              onClick={ handleCompareTrayAdd }>
              { compareBtnText }
            </Button>
          </CompareBtnWrapper>
        </Media.Desktop>
        {
          myStore &&
          <PriceLink bolder prevent handler={ handleFindLowerPriceClick }>
            Found a lower price? Let us know.
          </PriceLink>
        }
      </RightUpdatingBlock>
    </Block>
  )
}

ProductBlock.propTypes = {
  brandName: PropTypes.string,
  className: PropTypes.string,
  compareBtnText: PropTypes.string,
  compareDisabled: PropTypes.bool,
  compatibilityState: PropTypes.string,
  contextType: PropTypes.string,
  countFront: PropTypes.number,
  countRear: PropTypes.number,
  defaultValue: PropTypes.number,
  disableAddToQuote: PropTypes.bool,
  expanderMenu: PropTypes.arrayOf(PropTypes.shape()),
  handleAddNewVehicle: PropTypes.func,
  handleBeforeRemoveFavorite: PropTypes.func,
  handleCompareTrayAdd: PropTypes.func,
  handleFindLowerPriceClick: PropTypes.func,
  handleFrontQuantityChange: PropTypes.func,
  handleProductClick: PropTypes.func,
  handleRearQuantityChange: PropTypes.func,
  inventoryStatuses: PropTypes.arrayOf(PropTypes.shape()),
  isAllCompatible: PropTypes.bool,
  isEvItem: PropTypes.bool,
  isOeItem: PropTypes.bool,
  isPilotStore: PropTypes.bool,
  isTrailer: PropTypes.bool,
  itemEVType: PropTypes.string,
  myStore: PropTypes.shape(),
  onClick: PropTypes.func,
  product: PropTypes.shape(),
  productSkuId: PropTypes.string,
  promotions: PropTypes.arrayOf(PropTypes.shape()),
  promotionsPreviewItems: PropTypes.arrayOf(PropTypes.shape()),
  promotionsRestItems: PropTypes.arrayOf(PropTypes.shape()),
  quantityInputId: PropTypes.string,
  quantityUpdated: PropTypes.bool,
  rearSkuId: PropTypes.string,
  reviewsLink: PropTypes.string,
  showStoreLocatorModal: PropTypes.func,
  skuId: PropTypes.string,
  specification: PropTypes.arrayOf(PropTypes.shape()),
  staggeredSkuId: PropTypes.string,
  title: PropTypes.string,
  vehicleName: PropTypes.string
}

export default ProductBlock

const BrandLogo = styled(Logo)`
  max-width: 140px;
`

const FavoriteButtonHeart = styled(FavoriteButton)`
  position: absolute;
  ${Media.desktop`
    left: 170px;
    top: 20px;
  `}
  ${Media.mobile`
    right: 10px;
    top: 10px;
  `}
`

const ProductFlagWrapper = styled.div`
  margin-top: 20px;

  & > div {
    margin: 15px 0 0;
  }

  ${Media.mobile`
    & > div {
      margin: 5px 0;
    }
  `}
`
